type ProfileTitleProps = {
  title: string
  marginTop?: string
  marginBottom?: string
}
export default function ProfileTitle({
  title,
  marginTop = "40px",
  marginBottom = "0",
}: ProfileTitleProps) {
  return (
    <div className="title">
      {title}
      <style jsx>{`
        .title {
          position: relative;
          padding-left: 12px;
          font-size: 14px;
          color: #333333;
          margin-top: ${marginTop};
          margin-bottom: ${marginBottom};
        }
        .title::before {
          content: "";
          width: 4px;
          height: 14px;
          background-color: var(--primaryColor);
          position: absolute;
          left: 0;
          top: 0;
        }
      `}</style>
    </div>
  )
}
